import {
    CcReviewDocument,
    CcReviewDocumentCreate,
    MtDriveFile,
} from "server/models"

import { ASC, DESC } from "const"
import { replaceHistoryState } from "client/utils"
import { GET, POST, sort, sortByRevision } from "client/store/utils"

export const LoadCcReviewDocuments = (projectId: number) => (
    GET(`/ccReviewDocument/projectId/${projectId}`)
    .then((reviewDocuments: CcReviewDocument[]) => {
        const files: MtDriveFile[] = []
        reviewDocuments.forEach((row) => {
            if (row.file) {
                files.push({
                    ...row.file,
                    versions: row.file.versions.slice().sort((a, b) => sortByRevision(a.revision, b.revision, DESC)),
                })
            }
        })
        return files.sort((a, b) => sort(a, b, "name", ASC))
    })
)

export const AddCcReviewDocument = (data: CcReviewDocumentCreate) => (
    POST(
        "/ccReviewDocument/add",
        JSON.stringify(data),
    )
)

export const DeleteCcReviewDocument = (data: CcReviewDocumentCreate) => (
    POST(
        "/ccReviewDocument/delete",
        JSON.stringify(data),
    )
)

export const SetCcReviewHref = (
    baseRoute: string,
    tab: string,
    fileId: number,
    versionId: number,
) => {
    if (fileId && versionId) {
        replaceHistoryState(`${baseRoute}/${tab}/file/${fileId}/version/${versionId}`)
    } else if (fileId) {
        replaceHistoryState(`${baseRoute}/${tab}/file/${fileId}`)
    } else {
        replaceHistoryState(`${baseRoute}/${tab}`)
    }
}

export const SetCcReviewComplianceHref = (
    baseRoute: string,
    tab: string,
    fileId: number,
    versionId: number,
    setId: number,
    revisionId: number,
    itemId: number,
) => {
    // view compliance answer
    replaceHistoryState(`${baseRoute}/${tab}/file/${fileId}/version/${versionId}/set/${setId}/revision/${revisionId}/item/${itemId}`)
}

export const SetCcReviewReviewHref = (
    baseRoute: string,
    tab: string,
    fileId: number,
    versionId: number,
    itemId: number,
    revisionId: number,
) => {
    // view review answer
    replaceHistoryState(`${baseRoute}/${tab}/file/${fileId}/version/${versionId}/item/${itemId}/revision/${revisionId}`)
}

export const SetCcReviewReviewEditHref = (
    baseRoute: string,
    tab: string,
    fileId: number,
    versionId: number,
    itemId: number,
    revisionId: number,
) => {
    // edit review answer
    replaceHistoryState(`${baseRoute}/${tab}/file/${fileId}/version/${versionId}/editItem/${itemId}/revision/${revisionId}`)
}
